import { ErrorView } from "../../../components";

type Props = {
  username: string;
  goBack: () => void;
  onAskForHelp: (message: string) => void;
};
export default function ErrorRecovery({
  username,
  goBack,
  onAskForHelp,
}: Props) {
  function onHelpButtonPress() {
    onAskForHelp(`Hola! Tuve un error con un producto de ${username}`);
  }

  return (
    <ErrorView
      text="Tuvimos un error mostrándote este producto"
      onWhatsappHelpButtonPress={onHelpButtonPress}
      onClose={goBack}
    />
  );
}
